import { _t } from '@/i18n/t';

export interface PersonaSignal {
  tell: string;
  source: string;
}

const MINOR_WORDS = new Set(['a', 'an', 'and', 'for', 'in', 'of', 'on', 'the', 'to', 'with']);

function titleCase(slug: string): string {
  return slug
    .split('-')
    .filter(Boolean)
    .map((word, i) => (i > 0 && MINOR_WORDS.has(word) ? word : word.charAt(0).toUpperCase() + word.slice(1)))
    .join(' ');
}

export function personaSourceLabel(sourceId: string): string {
  const separator = sourceId.indexOf(':');
  if (separator === -1) return '';

  const kind = sourceId.slice(0, separator);
  const value = sourceId.slice(separator + 1);
  if (!value) return '';

  if (kind === 'page') return _t('onboarding.crawl.persona.sourcePage', { page: titleCase(value) });
  if (kind === 'reviews') return _t('onboarding.crawl.persona.sourceReviews', { platform: titleCase(value) });
  return '';
}

export function readPersonaSignals(value: unknown): PersonaSignal[] {
  if (!Array.isArray(value)) return [];

  return value.flatMap(entry => {
    if (!entry || typeof entry !== 'object') return [];
    const { tell, source } = entry as { tell?: unknown; source?: unknown };
    if (typeof tell !== 'string' || typeof source !== 'string') return [];
    if (tell.trim() === '' || source.trim() === '') return [];
    return [{ tell, source }];
  });
}
